module.exports = __webpack_public_path__ + "static/media/icon_planner.0f80ec44.svg";